// extracted by mini-css-extract-plugin
module.exports = {"font":"Home_font__19u0V"};